import { useTranslation } from "react-i18next";

import { IUnregisteredParty } from "../../../../setup/util/partyRegistration";
import { getPartyRoleTitle } from "../SettlementAdvisory/partyMappers";
import styles from "./styles.module.scss";

interface IUnregisteredPartiesAlert {
  parties: IUnregisteredParty[];
}

const UnregisteredPartiesAlert = ({ parties }: IUnregisteredPartiesAlert) => {
  const { t } = useTranslation();

  if (!parties.length) return null;

  return (
    <div className={styles.alert}>
      <span className={styles.bang}>!</span>
      <div className={styles.body}>
        <p className={styles.title}>
          {t("lbl_settlement_blocked_unregistered_parties")}
        </p>
        <ul className={styles.list}>
          {parties.map((party, index) => (
            <li key={`${party.role}-${index}`}>
              <span>{getPartyRoleTitle(party.role, t)}</span>
              {party.name && <span>{` — ${party.name}`}</span>}
              {party.phoneNumber && (
                <span className={styles.phone}>{` ${party.phoneNumber}`}</span>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default UnregisteredPartiesAlert;
